import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios"
import Vue2Filters from 'vue2-filters'
import Tooltip from 'vue-directive-tooltip';
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import VueI18n from 'vue-i18n'

import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
      var vm = vnode.context;
      var callback = binding.value;

      el.clickOutsideEvent = function (event) {
          if (!(el == event.target || el.contains(event.target))) {
              return callback.call(vm, event);
          }
      };
      document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
      document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

Vue.use(Tooltip, 
  {
      delay: 50,
      placement: 'auto',
      class: '', // ex: 'tooltip-custom tooltip-other-custom'
      triggers: ['hover', 'focus'],
      offset: 0
  });
Vue.use(Loading);
Vue.use(Vue2Filters)


import CripVueLoading from "crip-vue-loading"
import { languages } from './i18n';
// import { languages } from './i18n';

Vue.use(CripVueLoading, { axios })

Vue.use(Vuex)


Vue.config.productionTip = false
var shared = new Vue({data:{ smallerNavBar: false}})

shared.install = function(){
  Object.defineProperty(Vue.prototype, '$global', {
    get () { return shared }
  })
}
 const messages = Object.assign(languages)

Vue.use(VueI18n)

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: navigator.language.split('-')[0],
  fallbackLocale: 'en',
  messages, // set locale messages
})


Vue.use(shared);
const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
const store = new Vuex.Store({
  state: {
    broadcasterAuth: undefined,
    inApp: false,
    hideNavBar: false,
    broadcasterChannels: [],
  },
  mutations: {
    //mutate the state with payload.token if exists or payload.email and payload.key
    setAuth (state, payload) {
      state.broadcasterAuth = payload
    },
    setInApp (state, payload) {
      state.inApp = payload
    },
    setHideNavBar (state, payload) {
      state.hideNavBar = payload
    },
    setBroadcasterChannels (state, payload) {
      state.broadcasterChannels = payload
    }

  },
  plugins: [vuexLocal.plugin]
})
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
